import Chart from "chart.js/auto";

export default function doughnutChart() {
    Alpine.data('doughnutChart', () => ({
        chartData: {
            titles: [],
            values: []
        },
        chart: null,
        totalVal: 0,
        processData(title, value) {
            this.chartData.titles.push(title);
            this.chartData.values.push(value);
            this.totalVal = this.countTotalValue();
        },
        countTotalValue(){
            return this.chartData.values.reduce((a, b) => a + b, 0);
        },
        afterDraw(chart, args, options) {
            const { ctx, chartArea: {  width, height }} = chart;
            const deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            
            if (deviceWidth >= 450) {
                chart.data.datasets.forEach((dataset, i) => {
                    chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
                        const { x, y } = datapoint.tooltipPosition();
                        const halfWidth = width / 2;
                        const halfHeight = height / 2;
                        const xLine = x >= halfWidth ? x + 40 : x - 40;
                        const yLine = y >= halfHeight ? y + 40 : y - 40;
                        const textPosition = x >= halfWidth ? "left" : "right"
                        
                        ctx.textAlign = textPosition;
                        ctx.fontWeight = "bold";
                        ctx.textBaseline = "middle";
                        ctx.fillText(chart.config.data.datasets[0].data[index].toLocaleString(), xLine, yLine);
                    })
                })
            }
        },
        renderChart() {
            if(this.chart == null){
                const ctx = document.getElementById('doughnutChart');
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        labels: this.chartData.titles,
                        datasets: [{
                            data: this.chartData.values,
                            backgroundColor: [
                                '#FA4692',
                                '#006DFF',
                                '#000F8F'
                            ],
                        }]
                    },
                    options: {
                        cutout: "65%",
                        maintainAspectRatio: false,
                        layout: {
                            padding: 20
                        },
                        plugins: {
                            tooltip: {
                                boxPadding: 6,
                            },
                            legend: {
                                onClick: null,
                                position: 'bottom',
                                labels: {
                                    usePointStyle: true,
                                    padding: 30,
                                    color: "black",
                                    font: {
                                        size: 16,
                                        weight: 'bold',
                                    }
                                }
                            }
                        }
                    },
                    plugins: [{
                        afterDraw: this.afterDraw
                    }]
                });
            }
        }
    }));
}